module.exports = __webpack_public_path__ + "media/images/country_flags/eg-e717ddf32febaf0d8a88ba30c8ed4af5.png";